var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.textList),function(text,i){return _c('li',{class:("pad-t-d5 mrg-t-d5 " + (i===0? '': 'line-t thick-1 line-neutral'))},[_c('b',{staticClass:"color-yellow mrg-r-1"},[_vm._v("·")]),_vm._v(" "),_c('span',{staticClass:"alpha-d8"},[_vm._v(_vm._s(text))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eba7b3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list-widget.vue
// module id = null
// module chunks = 